import { render, staticRenderFns } from "./PeralteesList.vue?vue&type=template&id=fe1acac2&scoped=true&"
import script from "./PeralteesList.vue?vue&type=script&lang=ts&"
export * from "./PeralteesList.vue?vue&type=script&lang=ts&"
import style0 from "./PeralteesList.vue?vue&type=style&index=0&id=fe1acac2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe1acac2",
  null
  
)

export default component.exports